module.exports = __webpack_public_path__ + "static/media/card_s2.48dbc52f.jpg";